import React, { useReducer } from "react";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";

import { auth, db, analytic } from "../../server/firebase";
import authReducers from "./authReducers";
import authContext from "./authContex";
import tokenAuth from "../../config/tokenAuth";
import * as ROUTES from "../../constans/rutas";

import {
  REGISTRO_EXITOSO,
  REGISTRO_ERROR,
  OBTENER_USUARIO,
  LOGIN_EXITOSO,
  LOGIN_ERROR,
  CERRAR_SESION,
} from "../../types";
import axios from "axios";
import { URL_SERVICIO, URL_AWS } from "../../constans/servidor";

const AuthState = (props) => {
  const initialState = {
    token: localStorage.getItem("token"),
    autenticado: null,
    usuario: null,
    mensaje: null,
    cargando: true,
  };

  let history = useHistory();

  const [state, dispatch] = useReducer(authReducers, initialState);

  const registrarUsuario = async (datos) => {
    try {
      const respuesta = await auth.createUserWithEmailAndPassword(
        datos.email,
        datos.password
      );
      let user;
      if (respuesta.user) {
        user = await db.collection("Usuarios").doc(respuesta.user.uid).set({
          id: respuesta.user.uid,
          nombre: datos.nombre,
          email: datos.email,
        });
      }
      console.log(user);
      analytic.logEvent("registro_usuario", { page: "Beparking" });
      dispatch({
        type: REGISTRO_EXITOSO,
        payload: respuesta.user.uid,
      });

      // obtener usuarios
      usuarioAutenticado();
    } catch (error) {
      const alerta = {
        msg: error.message,
        categoria: "danger",
      };
      dispatch({
        type: REGISTRO_ERROR,
        payload: alerta,
      });
    }
  };

  const actualizarUsuario = async (cedula) => {
    const respuesta = await axios.get(
      `${URL_AWS}/beParking/consultaInfoUsuario/${cedula}`
    );
    dispatch({
      type: OBTENER_USUARIO,
      payload: { cms: false, ...respuesta.data.data },
    });
  };

  const usuarioAutenticado = async (usuario) => {
    let token = localStorage.getItem("token");
    console.log(token);

    if (token) {
      if (token === "FIREBASE") {
        auth.onAuthStateChanged((userAuth) => {
          console.log("Auth State Changed:", userAuth);
          if (userAuth) {
            db.collection("Usuarios")
              .doc(userAuth?.uid)
              .get()
              .then((doc) => {
                console.log(doc);
                if (doc.exists) {
                  const user = doc.data();
                  console.log(user);
                  dispatch({
                    type: OBTENER_USUARIO,
                    payload: { cms: true, ...user },
                  });
                } else {
                  dispatch({
                    type: LOGIN_ERROR,
                  });
                }
              })
              .catch((error) => {
                dispatch({
                  type: LOGIN_ERROR,
                });
              });

            toast.success("Login Exitoso", { toastId: "success1" });
          } else {
            dispatch({
              type: LOGIN_ERROR,
            });
          }
        });
      } else {
        const respuesta = await axios.get(
          `${URL_AWS}/beParking/consultaInfoUsuario/${token}`
        );

        dispatch({
          type: OBTENER_USUARIO,
          payload: { cms: false, ...respuesta.data.data },
        });

        history.push(ROUTES.HOME);
      }
    } else {
      dispatch({
        type: LOGIN_ERROR,
      });
    }

    // if(usuario){
    //     console.log('en usuario');
    //     localStorage.setItem('token', usuario.cedula)
    //     toast.success("Login exitoso");
    //     dispatch({
    //         type: OBTENER_USUARIO,
    //         payload: {cms: false, ...usuario}
    //     })
    // } else {
    //     console.log('en else');
    //     if(token){
    //         auth.onAuthStateChanged( (userAuth) => {
    //             if(userAuth){
    //                 db.collection('Usuarios').doc(userAuth?.uid).get()
    //                 .then( (doc) => {
    //                     if (doc.exists) {
    //                         const user = doc.data();
    //                         dispatch({
    //                             type: OBTENER_USUARIO,
    //                             payload: {cms: true, ...user}
    //                         })
    //                     } else {
    //                         dispatch({
    //                             type: LOGIN_ERROR
    //                         })
    //                     }
    //                 }).catch( (error) => {
    //                     dispatch({
    //                         type: LOGIN_ERROR
    //                     })
    //                 })
    //                 toast.success("Login exitoso");

    //             } else {
    //                 console.log('error')
    //                 dispatch({
    //                     type: LOGIN_ERROR
    //                 })
    //             }
    //         })
    //     }
    // }
  };

  const loginBeparking = async (datos) => {
    try {
      const respuesta = await axios.post(
        `${URL_AWS}/beParking/loginClienteWeb`,
        datos
      );

      if (!respuesta.data.estado) {
        toast.error(respuesta.data.mensaje);
      } else {
        analytic.logEvent("inicio_sesion", { page: "Beparking" });

        dispatch({
          type: LOGIN_EXITOSO,
          payload: datos.identificacion,
        });

        toast.success("Login exitoso");
        // obtener usuarios
        usuarioAutenticado(respuesta.data.data);
      }
    } catch (error) {
      console.log(error);
      toast.error(
        error.response ? error.response.data.mensaje : "Algo salio mal"
      );
    }
  };

  const iniciarSesion = async (datos) => {
    try {
      const respuesta = await auth.signInWithEmailAndPassword(
        datos.email,
        datos.password
      );
      console.log(respuesta);
      dispatch({
        type: LOGIN_EXITOSO,
        payload: "FIREBASE",
      });

      // obtener usuarios
      usuarioAutenticado();
    } catch (error) {
      const alerta = {
        msg: error.message,
        categoria: "danger",
      };
      dispatch({
        type: LOGIN_ERROR,
        payload: alerta,
      });
    }
  };

  const cerrarSesion = () => {
    auth
      .signOut()
      .then(() => {
        dispatch({
          type: CERRAR_SESION,
        });
      })
      .catch((error) => {
        const alerta = {
          msg: error.message,
          categoria: "danger",
        };
        dispatch({
          type: LOGIN_ERROR,
          payload: alerta,
        });
      });
  };

  return (
    <authContext.Provider
      value={{
        token: state.token,
        autenticado: state.autenticado,
        usuario: state.usuario,
        mensaje: state.mensaje,
        cargando: state.cargando,
        usuarioAutenticado,
        registrarUsuario,
        iniciarSesion,
        cerrarSesion,
        loginBeparking,
        actualizarUsuario,
      }}
    >
      {props.children}
    </authContext.Provider>
  );
};

export default AuthState;
